import { render, staticRenderFns } from "./ZgCatalog.vue?vue&type=template&id=a9d62b6e&scoped=true&"
import script from "./ZgCatalog.vue?vue&type=script&lang=js&"
export * from "./ZgCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ZgCatalog.vue?vue&type=style&index=0&id=a9d62b6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d62b6e",
  null
  
)

export default component.exports